import gql from "graphql-tag";

export const MY_HR_GET_LAST_PASSWORD_CHANGE = gql`
  query lastPasswordChange($email: String!) {
    lastPasswordChange(email: $email)
  }
`;
